module.exports = __webpack_public_path__ + "img/191.20b84170.jpg";